import {CustomerProductOverviewRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export class CustomerProductWithImageOverviewRestDtoModel {
    main_image_url: string | undefined;
    product: CustomerProductOverviewRestDto;

    constructor(product: CustomerProductOverviewRestDto, main_image_url: string | undefined = undefined) {
        this.main_image_url = main_image_url;
        this.product = product;
    }
}
